// extracted by mini-css-extract-plugin
module.exports = {"page":"DomainOut_page_GWx-l"};